//*************** OVERVIEW ****************//
/*
  gudhub_learning — light onboarding/teaching helper.

  V1 responsibility: on app load, if the current user has zero apps in
  their applist, redirect them into the existing "getting started" wizard
  (gh_elements/getting_started) so they can create their first app.

  main.js calls init() once during app.run() - after that this service is
  self-contained: it owns its own $routeChangeSuccess listener and decides
  entirely on its own whether/when to redirect. main.js never has to know
  what checks run or fold their results into its own routing logic.
*/

//*************** EXTENDING ****************//
/*
  Future onboarding checks (e.g. "no items in your first app yet") should
  be added as additional private functions called from checkRoute(), not
  as extra public methods main.js has to call - init() is the only thing
  main.js needs to invoke.
*/

angular
  .module('gudhubLearningModule', [])
  .service('gudhubLearning', ['$rootScope', '$location', '$window', function ($rootScope, $location, $window) {

    var GETTING_STARTED_PATH = '/act/getting_started';

    //*************** SKIP ROUTES ****************//
    // Loop/pre-auth guard: routes where we must never redirect into the
    // getting-started wizard - the auth screens (user may not be logged in
    // yet, or the login attempt just failed, so gudhub.getAppsList() can't
    // be trusted) and the wizard route itself (redirecting into the route
    // we're already on would loop forever).
    var SKIP_ROUTES = ['/login', '/signup', '/account-deleted', GETTING_STARTED_PATH];

    function isSkippedRoute(path) {
      return SKIP_ROUTES.some(function (route) {
        return path === route || path.indexOf(route + '/') === 0;
      });
    }

    //*************** CHECK ROUTE ****************//
    // Runs on every route change. First onboarding check: send a user
    // with zero apps to the getting-started wizard.
    function checkRoute() {
      var currentPath = $location.path();

      if (!$window.localStorage.auth_key || isSkippedRoute(currentPath)) {
        return;
      }

      gudhub.getAppsList().then(function (apps) {
        apps = apps || [];

        //*************** IGNORE SYSTEM APP ****************//
        // Every account carries a hidden system "init app"
        // (storage.getUser().app_init) that always shows up in
        // getAppsList() but isn't an app the user created - the rest of
        // the codebase filters it out too before treating the list as the
        // user's own apps (see slider_service.js, automations.controller.js).
        // Ignore it here too, otherwise a brand-new account (which only has
        // this system app) would never be seen as having zero apps.
        var defaultAppId = gudhub.storage.getUser().app_init;
        var realApps = apps.filter(function (app) {
          return app.app_id != defaultAppId;
        });

        // Re-check the path: the user may have navigated elsewhere while
        // gudhub.getAppsList() was resolving.
        if (realApps.length === 0 && !isSkippedRoute($location.path())) {
          $location.path(GETTING_STARTED_PATH);
        }
      });
    }

    //*************** INIT ****************//
    // Called once by main.js during app.run(). Wires up the route-change
    // listener that drives every onboarding check from here on.
    this.init = function () {
      $rootScope.$on('$routeChangeSuccess', checkRoute);
    };

  }]);
